export default __webpack_public_path__ + "static/media/hero-img.2a97c270.png";